import { Toaster } from 'react-hot-toast';
import { Icon, IconType } from './ui';

const StyledToaster = () => {
  return (
    <Toaster
      position='top-right'
      toastOptions={{
        style: {
          borderRadius: '8px',
          borderLeft: '4px solid var(--oliver-blue)',
          padding: '12px',
          background: 'hsl(var(--background))',
          color: 'hsl(var(--foreground))',
          minWidth: '150px',
          minHeight: '40px',
        },
        success: {
          duration: 2000,
          style: {
            borderLeft: '6px solid var(--approval)',
          },
          icon: (
            <div style={{ flexShrink: 0 }}>
              <Icon type={IconType.Final} width={25} height={25} />
            </div>
          ),
        },
        error: {
          duration: 2000,
          style: {
            borderLeft: '6px solid var(--oliver-red)',
          },
          icon: (
            <div style={{ flexShrink: 0 }}>
              <Icon type={IconType.Final} width={25} height={25} />
            </div>
          ),
        },
      }}
    />
  );
};

export default StyledToaster;
